import React, { useEffect, useMemo } from "react";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { RegistrationLayout } from "../../../RegistrationLayout/RegistrationLayout";
import { RegistrationSetupNavbar } from "../../../RegistrationLayout/RegistrationSetupNavbar";
import RegistrationSetupWrapper from "../../RegistrationSetup.style";
import {
  REGISTRATION_SETUP_STEP_META,
  REGISTRATION_SETUP_TOTAL_STEPS,
} from "../../../../helper/constants";
import { getRegistrationData } from "../../registrationSetupStorage";
import { buildConfirmationSummary } from "../registrationConfirmationMock";
import AddToCalendarButton from "../AddToCalendarButton/AddToCalendarButton";

const CONFIRM_STEP = REGISTRATION_SETUP_STEP_META.APPOINTMENT_CONFIRMED;

const RegistrationAppointmentConfirmed = ({ history }) => {
  const { t } = useTranslation();
  const registrationData = getRegistrationData();
  const summary = useMemo(
    () =>
      buildConfirmationSummary(
        registrationData,
        registrationData.calendlyAppointment ?? null
      ),
    [registrationData]
  );

  const confirmationRows = [
    { key: "dietitian", icon: "👩‍⚕️", label: t("NUTRITION_CONFIRM_LBL_DIETITIAN"), value: summary.dietitianDisplay },
    { key: "datetime", icon: "📅", label: t("NUTRITION_CONFIRM_LBL_DATE_TIME"), value: summary.dateTimeDisplay },
    { key: "payment", icon: "💳", label: t("NUTRITION_CONFIRM_LBL_PAYMENT"), value: summary.paymentDisplay },
    { key: "format", icon: "📹", label: t("NUTRITION_CONFIRM_LBL_FORMAT"), value: summary.formatDisplay },
  ].filter((row) => Boolean(row.value));

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const root = document.getElementById("root");
    const prevHtmlOverflow = html.style.overflow;
    const prevBodyOverflow = body.style.overflow;
    const prevRootHeight = root?.style.height ?? "";

    html.style.overflow = "hidden";
    body.style.overflow = "hidden";
    if (root) {
      root.style.height = "100vh";
      root.style.height = "100dvh";
    }

    if (!registrationData.bookedAppointment || !registrationData.selectedAppointment) {
      history.replace("/register/account/appointments");
    }

    return () => {
      html.style.overflow = prevHtmlOverflow;
      body.style.overflow = prevBodyOverflow;
      if (root) {
        root.style.height = prevRootHeight;
      }
    };
  }, [history, registrationData.bookedAppointment, registrationData.selectedAppointment]);

  return (
    <RegistrationSetupWrapper>
      <RegistrationLayout
        containScroll
        header={
          <RegistrationSetupNavbar
            stepMeta={CONFIRM_STEP}
            totalSteps={REGISTRATION_SETUP_TOTAL_STEPS}
            showBack={false}
          />
        }
      >
        <div className="scroll-body">
          <div className="content-card content-card-confirm">
            <div className="content-card-scroll">
              <div className="confirm-hero">
                <div className="confirm-check" aria-hidden>
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#2d3f52"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                </div>
                <h2 className="confirm-title">
                  {t("NUTRITION_CONFIRM_LBL_BOOKED_TITLE")}
                </h2>
                <p className="confirm-sub">
                  {t("NUTRITION_CONFIRM_DESC_BOOKED")}
                </p>
              </div>

              <div className="appt-detail">
                {confirmationRows.map((row) => (
                  <div key={row.key} className="appt-row">
                    <div className="appt-icon" aria-hidden>
                      {row.icon}
                    </div>
                    <div>
                      <div className="appt-label">{row.label}</div>
                      <div className="appt-value">{row.value}</div>
                    </div>
                  </div>
                ))}
              </div>

              {/* <div className="appt-id">
                Confirmation #: <strong>{summary.confirmationNumber}</strong>
              </div> */}

              <div className="confirm-action-box">
                <span className="confirm-action-icon" aria-hidden>
                  📱
                </span>
                <div>
                  <div className="confirm-action-title">
                    {t("NUTRITION_CONFIRM_LBL_ACTION_REQUIRED")}
                  </div>
                  <p className="confirm-action-text">
                    {t("NUTRITION_CONFIRM_DESC_DOWNLOAD_NOTICE")}
                  </p>
                </div>
              </div>

              <button
                type="button"
                className="btn-primary"
                onClick={() => history.push("/register/account/download-app")}
              >
                {t("NUTRITION_CONFIRM_BTN_DOWNLOAD_APP")}
              </button>
              <AddToCalendarButton
                registrationData={registrationData}
                calendlyAppointment={registrationData.calendlyAppointment ?? null}
              />
            </div>
          </div>
        </div>
      </RegistrationLayout>
    </RegistrationSetupWrapper>
  );
};

export default withRouter(RegistrationAppointmentConfirmed);
